// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"579":"4c4e627e","949":"04dac1d7"}[chunkId] + ".chunk.css";
};